import dayjs from 'dayjs';

import messages from '../constants/messages';

const requiredTaskFields = [
  { value: 'title', text: 'Title' },
  { value: 'startDate', text: 'Start date' },
  { value: 'endDate', text: 'End date' }
];

export const validateEvent = event => {
  for (const requiredField of requiredTaskFields) {
    if (!event[requiredField.value]) {
      return messages.FIELD_REQUIRED(requiredField.text);
    }
  }

  if (event.relationType && !event.relationIds?.length) {
    return messages.EVENT_PROVIDE_RELATION;
  }

  const currentTimestamp = +new Date();
  const startTimestamp = +new Date(event.startDate);
  const endTimestamp = +new Date(event.endDate);
  const remindTimestamp = event.remindDate ? +new Date(event.remindDate) : null;

  if (startTimestamp >= endTimestamp) {
    return messages.EVENT_START_DATE_AFTER_END_DATE;
  }

  if (remindTimestamp && remindTimestamp < currentTimestamp) {
    return messages.EVENT_REMIND_DATE_IN_PAST;
  }

  if (remindTimestamp && remindTimestamp > startTimestamp) {
    return messages.EVENT_REMIND_DATE_AFTER_START_DATE;
  }

  if (event.recurringType && !event.recurringEndDate) {
    return messages.EVENT_PROVIDE_RECURRING_DATE;
  }

  return null;
};

export const getEventStatus = status => {
  switch (status) {
    case null: {
      return 'Pending';
    }
    case 'accepted': {
      return 'Accepted';
    }
    case 'declined': {
      return 'Declined';
    }
    default: {
      return status;
    }
  }
};

export const getEventNullState = (startDate, endDate) => {
  return {
    description: '',
    endDate: endDate || dayjs().add(2, 'h'),
    recurringEndDate: null,
    recurringType: null,
    relationIds: [],
    relationType: null,
    relations: [],
    remindDate: null,
    startDate: startDate || dayjs(),
    title: '',
    userEmails: [],
    userIds: []
  };
};
